import { render, staticRenderFns } from "./homomorphicDetail.vue?vue&type=template&id=eb50f640&scoped=true&"
import script from "./homomorphicDetail.vue?vue&type=script&lang=js&"
export * from "./homomorphicDetail.vue?vue&type=script&lang=js&"
import style0 from "./homomorphicDetail.vue?vue&type=style&index=0&id=eb50f640&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb50f640",
  null
  
)

export default component.exports